export default {
  getItemInfo: state => state.itemInfo,
  getVariants: state => state.itemInfo.variants,
  getVariantsSku: state => {
    return state.itemInfo.variants
      ? state.itemInfo.variants.map(g => g.sku)
      : [];
  },
  getBrandList: state => state.brandList,
  getQuantity: state => state.quantity,
  getInputState: state => Object.values(state.inputState).every(s => s),
  getVariationId: state => state.variationId
};
